import { ScrollText } from "lucide-react";
import { Badge } from "@/components/ui/badge";
import { SEO } from "@/components/seo/SEO";
import { MotionReveal } from "@/components/shared/MotionReveal";
import { FIRM } from "@/constants/firmInfo";
import { useLanguage, fillTemplate } from "@/i18n/LanguageContext";

export default function Terms() {
  const { t } = useLanguage();
  const sections = t("legal.terms.sections");

  return (
    <>
      <SEO
        title={t("seo.terms.title")}
        description={t("seo.terms.description")}
        path="/terms"
      />
      <header className="bg-[color:var(--paper-2)] border-b border-slate-200 py-14 sm:py-16">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="h-12 w-12 rounded-2xl bg-[color:var(--navy-950)] grid place-items-center mb-5">
            <ScrollText className="h-6 w-6 text-[color:var(--gold-400)]" />
          </div>
          <h1 className="font-heading text-3xl sm:text-4xl font-medium text-[color:var(--navy-950)]">{t("legal.terms.title")}</h1>
          <Badge variant="secondary" className="mt-3 bg-white border border-slate-200 text-slate-500 font-normal">{t("legal.terms.updated")}</Badge>
        </div>
      </header>

      <MotionReveal className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-14 sm:py-16">
        <div className="prose prose-slate max-w-none prose-headings:font-heading prose-headings:text-[color:var(--navy-950)] prose-p:text-slate-600 prose-p:leading-7 prose-h2:mt-9 prose-h2:pb-2 prose-h2:border-b prose-h2:border-slate-100 prose-a:text-[color:var(--navy-950)]">
          <p>{t("legal.terms.intro")}</p>

          {sections.map((s) => (
            <div key={s.heading}>
              <h2>{s.heading}</h2>
              <p>{fillTemplate(s.body, { firmName: FIRM.name })}</p>
            </div>
          ))}

          <h2>{t("legal.terms.contactHeading")}</h2>
          <p>
            {t("legal.terms.contactPrefix")} <a href={`mailto:${FIRM.email}`}>{FIRM.email}</a>{" "}
            {t("legal.terms.contactMiddle")} {FIRM.phoneDisplay}.
          </p>
        </div>
      </MotionReveal>
    </>
  );
}
